import axios from './axios';
import config from '../../helpers/config';

export default (designId, itemId) => (
  axios.delete(`${config.designBuilderLoadDesignPath}/${designId}/items/${itemId}`)
);
